import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { graphql, useStaticQuery } from 'gatsby'

const PageTopStyle = styled.div`
width: 100%;
height: 450px;
position: relative;
font-family: var(--gothic);
display: flex;
align-items: flex-end;
justify-content: center;
flex-direction: column;
box-sizing: border-box;
.image {
    width: 100%;
    overflow: hidden;
    height: 100%;
    filter: brightness(0.5);
    z-index: -1;
}
.pagetop-title {
    position: absolute !important;
    font-size: 32px;
    letter-spacing: 0.1em;
    color: var(--white-color-1);
    margin-right: 20%;
    font-weight: 600;
    transform: translateY(40px);
    @media screen and (max-width: 600px) {
        transform: translate(-20%, 40px);
    }
}
.pagetop-bar {
    width: 100%;
    background: var(--white-color-3);
    padding: 10px 0;
    text-align: center;
    .breadlist {
        text-align: left;
        max-width: 920px;
        padding: 0 40px;
        margin: auto;
        font-size: 14px;
        font-weight: 300;
    }
}
`

function PageTop({title, photoNum}) {
    const data = useStaticQuery(graphql`
    query {
        pageTopImage1: file(relativePath: { eq: "pagetop1.webp" }) {
            childImageSharp {
                fluid(maxWidth: 1920, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage2: file(relativePath: { eq: "pagetop2.webp" }) {
            childImageSharp {
                fluid(maxWidth: 1920, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage3: file(relativePath: { eq: "pagetop3.webp" }) {
            childImageSharp {
                fluid(maxWidth: 1920, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage4: file(relativePath: { eq: "pagetop4.webp" }) {
            childImageSharp {
                fluid(maxWidth: 1920, quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage12: file(relativePath: { eq: "pagetop1-2.webp" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 50) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage22: file(relativePath: { eq: "pagetop2-2.webp" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 50) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage32: file(relativePath: { eq: "pagetop3-2.webp" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 50) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        pageTopImage42: file(relativePath: { eq: "pagetop4-2.webp" }) {
            childImageSharp {
                fluid(maxWidth: 500, quality: 50) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
    `)
    let backImg = data.pageTopImage1
    if (photoNum) {
        backImg = 
            photoNum===1 ? data.pageTopImage1 : 
            photoNum===2 ? data.pageTopImage2 : 
            photoNum===3 ? data.pageTopImage3 : 
            photoNum===4 ? data.pageTopImage4 :
            photoNum===12 ? data.pageTopImage12 : 
            photoNum===22 ? data.pageTopImage22: 
            photoNum===32 ? data.pageTopImage32 : 
            data.pageTopImage42
    }
    return (
        <PageTopStyle>
            <h2 className='pagetop-title'>{title}</h2>
            <Img
                fluid={backImg.childImageSharp.fluid} 
                className="image" 
            />
        </PageTopStyle>
    )
}

export default PageTop
